// @flow
import invariant from 'invariant';
import { v4 as uuidv4 } from 'uuid';

export const CR: '\r' = '\r';
export const LF: '\n' = '\n';
export const CRLF: '\r\n' = '\r\n';
export const DEFAULT_LINE_END: typeof LF = LF;

export type LINE_END = typeof CR | typeof LF | typeof CRLF;
export opaque type Char = string;

export const char = (ch: string): Char => {
  invariant(ch.length === 1, 'A Char must be exactly one character.');

  return ch;
};

export const asString = (ch: Char): string => ch;

export const byteLength = (str: string): number => new Blob([str]).size;

export const uniqueIdentifier = uuidv4;

export const initials = (str: string): string =>
  str
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0])
    .join('')
    .toUpperCase();

export const lineWrap = (str: string, length: number): string => {
  const data = str
    .match(new RegExp(`.{1,${length}}`, 'g'))
    ?.map((str1) => str1.trim());
  return data ? data.join(LF) : str;
};

export const titleCase = (str: string): string =>
  str?.length > 0
    ? str
        .split(' ')
        .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
        .join(' ')
    : '';
